import { render, staticRenderFns } from "./EditarCasamento.vue?vue&type=template&id=9fd5672a&"
import script from "./EditarCasamento.vue?vue&type=script&lang=js&"
export * from "./EditarCasamento.vue?vue&type=script&lang=js&"
import style0 from "./EditarCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports